import { sortBy } from 'lodash';
import Resources from '../../helpers/resources';
import { handleResourceSuccess, handleResourceError } from '../../helpers/resource-handlers';
import { PRIMARY, SECONDARY } from '../../components/certificate-template/certificate-template-constants';

export const STUDENT_CERTIFICATES_RETRIEVED = 'STUDENT_CERTIFICATES_RETRIEVED';

function getStudentCertificates({ startDate, endDate, classroomId, productId }) {
    return dispatch => Resources
        .studentCertificates
        .get({ classroomId })
        .withParams({ productId, startDate, endDate })
        .send()
        .then(
            (payload) => {
                const data = payload.data;
                if (data && data.studentsCertificatesSummary) {
                    let mappedStudentList = data.studentsCertificatesSummary.map(studentData => ({
                        id: studentData.userProfileId,
                        userId: studentData.userId,
                        firstName: studentData.firstName,
                        lastName: studentData.lastName,
                        pastCertificates: studentData.pastCertificates,
                        certificates: studentData.certificates
                    }));
                    mappedStudentList = sortBy(mappedStudentList, ['lastName', 'firstName']);
                    const mappedData = {
                        schoolType: data.isPrimary ? PRIMARY : SECONDARY,
                        allStudents: {
                            pastCertificates: data.classPastCertificates,
                            certificates: data.classCertificates,
                            total: data.total
                        },
                        studentList: mappedStudentList
                    };
                    return handleResourceSuccess(dispatch, payload, {
                        type: STUDENT_CERTIFICATES_RETRIEVED,
                        payload: mappedData
                    });
                }

                return handleResourceError(dispatch, payload.message);
            },
            error => handleResourceError(dispatch, error)
        );
}

export default {
    getStudentCertificates
};



// WEBPACK FOOTER //
// ./containers/certificates/student-certificates-actions.js